import React from 'react'

import Highlight from '../../Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

import ActivityOwner from '../ActivityOwner'
import { useLocation } from 'react-router-dom'

export default function QuoteTagsChangedActivity(props: ActivityTypeComponentProps) {
  const { activity } = props
  const location = useLocation()
  const isQuotePage = location.pathname.includes('/quotes/') || location.pathname.includes('/invoices/')
  const addedTags = activity.details.events

  return (
    <>
      <ActivityTitle>
        <Highlight>Tag{addedTags.length > 1 ? 's' : ''}</Highlight> {addedTags.length > 1 ? 'were' : 'was'}{' '}
        <Highlight>added</Highlight>
        <ActivityOwner activity={activity} />
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={!isQuotePage} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
